import { Box, Text } from "@nulogy/components";
import Input from "components/controls/Input";
import Select from "components/controls/Select";
import TimePicker from "components/controls/TimePicker";
import styled from "styled-components";

const GridBox4 = styled(Box)`
  display: grid;
  grid-template-columns: 450px 230px 100px 100px;
`;

const GridBox6 = styled(Box)`
  display: grid;
  grid-template-columns: 320px 320px 150px 150px 100px 100px;
`;

const GridBoxPlannedBreaks = styled(Box)`
  display: grid;
  grid-template-columns: 200px minmax(256px, 1fr) 256px 140px 140px 100px 100px;
`;

const GridBox7 = styled(Box)`
  display: grid;
  grid-template-columns: 40px 320px 320px 200px 200px 100px 100px;
`;

const StyledInput = styled(Input)(({ theme }) => ({
  input: {
    height: "41px",
  },
  marginBottom: `${theme.sizes.none} !important`,
  padding: `${theme.sizes.x1} ${theme.sizes.x2} ${theme.sizes.x1} ${theme.sizes.none}`,
}));

const StyledSelect = styled(Select)(({ theme }) => ({
  padding: `${theme.sizes.x1} ${theme.sizes.x2} ${theme.sizes.none} ${theme.sizes.none}`,
}));

const StyledText = styled(Text)(({ theme }) => ({
  padding: `${theme.sizes.x2} ${theme.sizes.x2} ${theme.sizes.x2} ${theme.sizes.none}`,
}));

const StyledTimePicker = styled(TimePicker)(({ theme }) => ({
  input: {
    height: "41px",
  },
  padding: `${theme.sizes.x1} ${theme.sizes.x2} ${theme.sizes.x1} ${theme.sizes.none}`,
}));

export { GridBox4, GridBox6, GridBoxPlannedBreaks, GridBox7, StyledInput, StyledText, StyledTimePicker, StyledSelect };
